import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <div>
        <p className={styles.heading}>【教材が開放されていない場合】</p>
        <p className={styles.text}>
          指導画面のメニュー［教材］から表示したいLessonを選択し、［生徒に公開する］を選んでください。
          <br />
          教材が開放され、生徒の画面に教材が表示されます。
        </p>
      </div>
    </div>
    <div>
      <p className={styles.heading}>【生徒の教材設定が無効になっている場合】</p>
      <p className={styles.text}>
        学校管理画面［生徒登録］の一覧で、「教材対象」の列が「○」に設定されているか確認してください。
        <br />
        「○」に設定すると、生徒が教材を見られるようになります。
        <br />
        ※学校管理者権限をお持ちでない先生は、権限を持っている先生に設定変更を依頼してください。
      </p>
    </div>
  </div>
);

export const STUDENT_MATERIAL_NOT_DISPLAYED_FAQ: FaqCategoryItem = {
  id: "student-material-not-displayed-faq",
  question: "生徒画面に教材が表示されない",
  Answer,
};
